import { render, staticRenderFns } from "./PrintPallet.vue?vue&type=template&id=7a36fc07&scoped=true"
import script from "./PrintPallet.vue?vue&type=script&lang=js"
export * from "./PrintPallet.vue?vue&type=script&lang=js"
import style0 from "./PrintPallet.vue?vue&type=style&index=0&id=7a36fc07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a36fc07",
  null
  
)

export default component.exports